import React, { useState } from "react";

const AddUserModal = ({ onClose, getToken, BACKEND_URL }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [newUserRole, setNewUserRole] = useState("user");
  const [busy, setBusy] = useState(false);

  const handleAddUser = async () => {
    if (!username.trim() || !password.trim()) {
      alert("Enter all fields");
      return;
    }

    setBusy(true);
    try {
      const res = await fetch(`${BACKEND_URL}/auth/create_user`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}),
        },
        body: JSON.stringify({
          username: username.trim(),
          password: password.trim(),
          role: newUserRole,
        }),
      });

      if (!res.ok) {
        const err = await res.text();
        alert("Failed: " + err);
      } else {
        alert("✅ User added!");
        setUsername("");
        setPassword("");
        onClose(); // close modal cleanly
      }
    } catch (e) {
      console.error("Network error:", e);
      alert("Network issue");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm animate-fadeIn">
      <div className="bg-white/90 border rounded-2xl shadow-2xl p-6 w-[90%] max-w-md animate-slideUp">
        <h3 className="text-xl font-semibold text-indigo-700 mb-4 text-center">
          Add New User
        </h3>

        <div className="space-y-4">
          <input
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full px-4 py-3 border rounded-lg focus:border-indigo-500 outline-none"
          />
          <input
            placeholder="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-3 border rounded-lg focus:border-indigo-500 outline-none"
          />

          <select
            value={newUserRole}
            onChange={(e) => setNewUserRole(e.target.value)}
            className="w-full px-4 py-3 border rounded-lg focus:border-indigo-500 outline-none"
          >
            <option value="user">User</option>
            <option value="admin">Admin</option>
          </select>
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300 transition font-medium"
          >
            Cancel
          </button>
          <button
            onClick={handleAddUser}
            disabled={busy}
            className="px-4 py-2 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 font-semibold transition disabled:opacity-50"
          >
            {busy ? "Adding..." : "Add User"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddUserModal;
